export function NotFoundImage() {
    return (
      <div className="py-20 px-4 sm:px-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-10 sm:gap-20">
          <img src="/images/404.svg" alt="Not Found" className="block sm:hidden" />
          <div>
            <h1 className="text-4xl font-extrabold mb-4">Something is not right...</h1>
            <p className="text-lg text-gray-500">
              The page you are trying to open does not exist. You may have mistyped the address, or the
              page has been moved to another URL. If you think this is an error, contact support.
            </p>
            <a href="/">
            <button className="mt-6 px-6 py-2 border border-gray-500 text-gray-700 rounded-md hover:bg-gray-100 w-full sm:w-auto">
              Get back to home page
            </button>
            </a>
            
          </div>
          <img src="/images/404.svg" alt="Not Found" className="hidden sm:block" />
        </div>
      </div>
    );
  }

  export default NotFoundImage